module.exports = __webpack_public_path__ + "img/jose-hero.49a94ee9.png";